import { ActionReducer, Action } from "@ngrx/store"
import { ConstantsStore } from "@store/constants"

export const constantsReducer: ActionReducer<ConstantsStore> = (state: ConstantsStore = new ConstantsStore(), action: Action) => {


  switch(action.type) {
    case POPULATE_CONSTANTS:
      return new ConstantsStore(
        action.payload,
        state.upcomingTerm)

    case POPULATE_UPCOMING_TERM:
      return new ConstantsStore(
        state.constants,
        action.payload)

    default:
      return state

  }
}

export const FETCH_CONSTANTS = "FETCH_CONSTANTS"
export const POPULATE_CONSTANTS = "POPULATE_CONSTANTS"
export const FETCH_CONSTANTS_FAILURE = "FETCH_CONSTANTS_FAILURE"
export const FETCH_UPCOMING_TERM = "FETCH_UPCOMING_TERM"
export const POPULATE_UPCOMING_TERM = "POPULATE_UPCOMING_TERM"
export const FETCH_UPCOMING_TERM_FAILURE = "FETCH_UPCOMING_TERM_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/constants.ts